module.exports = __webpack_public_path__ + "static/img/homeBigImg.ad4057a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homeBigImg.png
// module id = ALPj
// module chunks = 6